<i class="{{ getIcon() }}"></i>
